import { ModalId } from '@heidi/schema/ml-scribe';

/**
 * Session Merge onboarding modal IDs.
 */
export const SESSION_MERGE_ONBOARDING_MODAL_ID = ModalId.SESSION_MERGE_ONBOARDING;
/**
 * Second-chance awareness card shown on the settings screen when the user
 * didn't enable from Home — separate seen-state from the Home card so it can
 * re-prompt once on settings.
 */
export const SESSION_MERGE_ONBOARDING_SETTINGS_MODAL_ID =
  ModalId.SESSION_MERGE_ONBOARDING_SETTINGS;
export const SESSION_MERGE_EDUCATION_MODAL_ID = ModalId.SESSION_MERGE_EDUCATION;
export const SESSION_MERGE_TAB_COACHMARK_MODAL_ID = ModalId.SESSION_MERGE_TAB_COACHMARK;
